// header-search.js
// header-search
(function($, doc) {

  var $headerSearchToggle = $('#js-header-search-toggle');
  var $headerSearch = $('.header-search');

  $headerSearchToggle.click(function() {
    $headerSearch.toggleClass('open');
  });

})(jQuery, document);
